import React, { useEffect, useState } from "react";
import "./FlightPath.scss";
import { getFlightPath } from "../../services/otsEventService";
import { useAuthentication } from "meportal/AuthenticationProvider";
import { viewflightSchedule } from "../../store/feature/FlightScheduleSlice";
import { FlightLeg } from "../../Models/FlightLeg";
import { useDispatch, useSelector } from "react-redux";

type FlightPathProps = {
  aircraftNumber: string;
  isTailValid: boolean;
};

const FlightPath: React.FC<FlightPathProps> = ({ aircraftNumber,isTailValid }) => {
  const { userData, getLatestAccessToken } = useAuthentication();
  const dispatch = useDispatch();
  const flightPathInfo = useSelector(
    (state: any) => state.flightPath.flightPath
  );
  const [error, setError] = useState(false);
  const [noFlightPathData, setNoData] = useState(false);

  const headers = [
    "Flight",
    "Origin",
    "SetD",
    "ETD",
    "Out",
    "Off",
    "Dest",
    "SetA",
    "ETA",
    "On",
    "In",
    // 'Dispatcher',
    // 'D'
  ];

  const handleAnchorClick = () => {
    fetchFlightPath();
  };

  const errorMessage = (
    <React.Fragment>
      <div className="error-message">
        <div className="message-inline ">
          <svg
            className="alert-svg"
            width="24"
            height="24"
            viewBox="0 0 30 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="fluent:warning-32-filled">
              <path
                id="Vector"
                d="M17.8725 4.07094C16.6238 1.81156 13.3763 1.81156 12.1275 4.07094L2.29034 21.8825C1.08284 24.0687 2.66534 26.75 5.16284 26.75H24.8382C27.3357 26.75 28.9182 24.0687 27.7097 21.8825L17.8725 4.07094ZM16.1719 21.125C16.1719 21.4358 16.0484 21.7339 15.8287 21.9536C15.6089 22.1734 15.3108 22.2969 15 22.2969C14.6892 22.2969 14.3912 22.1734 14.1714 21.9536C13.9516 21.7339 13.8282 21.4358 13.8282 21.125C13.8282 20.8142 13.9516 20.5161 14.1714 20.2964C14.3912 20.0766 14.6892 19.9531 15 19.9531C15.3108 19.9531 15.6089 20.0766 15.8287 20.2964C16.0484 20.5161 16.1719 20.8142 16.1719 21.125ZM15 8.9375C15.2487 8.9375 15.4871 9.03627 15.6629 9.21208C15.8388 9.3879 15.9375 9.62636 15.9375 9.875V17.375C15.9375 17.6236 15.8388 17.8621 15.6629 18.0379C15.4871 18.2137 15.2487 18.3125 15 18.3125C14.7514 18.3125 14.5129 18.2137 14.3371 18.0379C14.1613 17.8621 14.0625 17.6236 14.0625 17.375V9.875C14.0625 9.62636 14.1613 9.3879 14.3371 9.21208C14.5129 9.03627 14.7514 8.9375 15 8.9375Z"
                fill="#DE750C"
              />
            </g>
          </svg>
          <div className="error-message-container">
            <span className="error-message-1">Network Request Failed</span>
            <span className="error-message-2">
              We’re having trouble connecting to server.
            </span>
          </div>
        </div>
        <button id="error-message" onClick={handleAnchorClick}>
          {" "}
          Try again
        </button>
      </div>
      <div></div>
    </React.Fragment>
  );

  const noDataMessage = (
    <React.Fragment>
      <div className="message-inline ">
        <svg
          className="alert-svg"
          width="24"
          height="24"
          viewBox="0 0 30 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="fluent:warning-32-filled">
            <path
              id="Vector"
              d="M17.8725 4.07094C16.6238 1.81156 13.3763 1.81156 12.1275 4.07094L2.29034 21.8825C1.08284 24.0687 2.66534 26.75 5.16284 26.75H24.8382C27.3357 26.75 28.9182 24.0687 27.7097 21.8825L17.8725 4.07094ZM16.1719 21.125C16.1719 21.4358 16.0484 21.7339 15.8287 21.9536C15.6089 22.1734 15.3108 22.2969 15 22.2969C14.6892 22.2969 14.3912 22.1734 14.1714 21.9536C13.9516 21.7339 13.8282 21.4358 13.8282 21.125C13.8282 20.8142 13.9516 20.5161 14.1714 20.2964C14.3912 20.0766 14.6892 19.9531 15 19.9531C15.3108 19.9531 15.6089 20.0766 15.8287 20.2964C16.0484 20.5161 16.1719 20.8142 16.1719 21.125ZM15 8.9375C15.2487 8.9375 15.4871 9.03627 15.6629 9.21208C15.8388 9.3879 15.9375 9.62636 15.9375 9.875V17.375C15.9375 17.6236 15.8388 17.8621 15.6629 18.0379C15.4871 18.2137 15.2487 18.3125 15 18.3125C14.7514 18.3125 14.5129 18.2137 14.3371 18.0379C14.1613 17.8621 14.0625 17.6236 14.0625 17.375V9.875C14.0625 9.62636 14.1613 9.3879 14.3371 9.21208C14.5129 9.03627 14.7514 8.9375 15 8.9375Z"
              fill="#DE750C"
            />
          </g>
        </svg>
        <div className="no-data-message">
          <span>No Flights Scheduled for This Aircraft</span>
        </div>
      </div>
      <div></div>{" "}
    </React.Fragment>
  );

  function FlightPathTable(props: any) {
    const formatDateTime = (zuluDateTime: string | null | undefined) => {
      if (!zuluDateTime) {
        return "";
      }

      const date = new Date(zuluDateTime ?? "");
      let hours = date.getUTCHours().toString();
      let minutes = date.getUTCMinutes().toString();

      hours = hours.length < 2 ? `0${hours}` : hours;
      minutes = minutes.length < 2 ? `0${minutes}` : minutes;

      const formattedTime = `${hours}:${minutes}`;

      return formattedTime;
    };

    React.useEffect(() => {
      if (aircraftNumber.length < 5) {
        setNoData(false);
      }
    }, [aircraftNumber]);

    const formatDate = (inputDateTime: string | null | undefined) => {
      if (!inputDateTime) {
        return "";
      }
      const [datePart] = inputDateTime.split("T");
      const [year, month, day] = datePart.split("-");
      return `${month}/${day}`; // Format as MM/dd
    };
    const warningAlert = (width: number, height: number) => (
      <React.Fragment>
        <span className="warning-alert">
          <svg
            width={width}
            height={height}
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.51074 12.9155C2.19336 12.9155 1.91829 12.8457 1.68555 12.7061C1.45703 12.5706 1.2793 12.3844 1.15234 12.1475C1.02539 11.9147 0.961914 11.6545 0.961914 11.3667C0.961914 11.117 1.03174 10.8652 1.17139 10.6113L6.16064 1.68652C6.30452 1.42839 6.49707 1.23372 6.73828 1.10254C6.98372 0.967122 7.23763 0.899414 7.5 0.899414C7.76237 0.899414 8.01416 0.967122 8.25537 1.10254C8.49658 1.23372 8.68913 1.42839 8.83301 1.68652L13.8286 10.605C13.8963 10.7277 13.9471 10.8525 13.981 10.9795C14.0148 11.1064 14.0317 11.2355 14.0317 11.3667C14.0317 11.6545 13.9683 11.9147 13.8413 12.1475C13.7186 12.3844 13.5409 12.5706 13.3081 12.7061C13.0754 12.8457 12.8003 12.9155 12.4829 12.9155H2.51074ZM7.50635 8.66895C7.83643 8.66895 8.00358 8.49544 8.00781 8.14844L8.10303 4.69531C8.10726 4.53027 8.05013 4.39274 7.93164 4.28271C7.81738 4.16846 7.6735 4.11133 7.5 4.11133C7.32227 4.11133 7.17627 4.16634 7.06201 4.27637C6.95199 4.38639 6.89909 4.52393 6.90332 4.68896L6.98584 8.14844C6.9943 8.49544 7.16781 8.66895 7.50635 8.66895ZM7.50635 10.7954C7.69678 10.7954 7.86182 10.7298 8.00146 10.5986C8.14535 10.4674 8.21729 10.3066 8.21729 10.1162C8.21729 9.92578 8.14535 9.76497 8.00146 9.63379C7.86182 9.49837 7.69678 9.43066 7.50635 9.43066C7.31169 9.43066 7.14453 9.49837 7.00488 9.63379C6.86523 9.76921 6.79541 9.93001 6.79541 10.1162C6.79541 10.3066 6.86523 10.4674 7.00488 10.5986C7.14876 10.7298 7.31592 10.7954 7.50635 10.7954Z"
              fill="#DE750C"
            />
          </svg>
        </span>
      </React.Fragment>
    );

    const hasCancellationInformation =
      Array.isArray(props.flightPathInfos) &&
      props.flightPathInfos.some(
        (info: FlightLeg) =>
          info.Cancellation && info.Cancellation?.includes("CXL")
      );
    let previousDate: string | null = null;
    return (
      <>
        <div className="table-boxing-container">
          <div className="flight-info-header">
            <table
              className={"flight-path-table-header" + (error ? "-error" : "")}
            >
              <thead>
                <tr className="flight-path-row">
                  {/*<tr key="header">*/}
                  {headers.map((header: any, index: number) => (
                    <th
                      key={header}
                      className={
                        hasCancellationInformation
                          ? "flight-path-headers cancellation"
                          : "flight-path-headers"
                      }
                    >
                      {index === 0 && (
                        <span
                          className={
                            hasCancellationInformation
                              ? "hidden-warning warning-gap"
                              : ""
                          }
                        >
                          {hasCancellationInformation && warningAlert(12, 12)}
                        </span>
                      )}
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          {Array.isArray(props.flightPathInfos) &&
            props.flightPathInfos.length > 0 && (
              <div className="table-boxing">
                <table
                  className={
                    "flight-path-table" +
                    (error || noFlightPathData ? "-error" : "")
                  }
                >
                  <tbody>
                    {props.flightPathInfos?.map((info: FlightLeg) => {
                      const currentDate = formatDate(info.SETD);
                      const showSeparator =
                        previousDate && currentDate !== previousDate;
                      previousDate = currentDate;
                      return (
                        <React.Fragment
                          key={
                            info.FlightNumber +
                            info.OriginLocation +
                            info.DestinationLocation
                          }
                        >
                          {showSeparator && (
                            <tr className="date-separator">
                              <td colSpan={11} className="date-separator-cell">
                                {currentDate}
                              </td>
                            </tr>
                          )}
                          <tr
                            className={
                              info.Cancellation?.includes("CXL")
                                ? "cancellation-row"
                                : "info"
                            }
                            key={info.FlightNumber}
                          >
                            <td className="flp-text">
                              <div
                                className={
                                  hasCancellationInformation
                                    ? "flp-warning"
                                    : ""
                                }
                              >
                                <span
                                  className={
                                    !info.Cancellation?.includes("CXL")
                                      ? "hidden-warning"
                                      : ""
                                  }
                                >
                                  {hasCancellationInformation &&
                                    warningAlert(15, 14)}
                                </span>{" "}
                                <span
                                  className={
                                    !info.Cancellation?.includes("CXL")
                                      ? "flight-text"
                                      : ""
                                  }
                                >
                                  {info.FlightNumber}
                                </span>
                              </div>
                            </td>
                            <td className="flp-text">{info.OriginLocation}</td>
                            <td className="flp-text">
                              {formatDateTime(info.SETD)}
                            </td>
                            <td className="flp-text">
                              {formatDateTime(info.EstimatedOutDateTimeUTC)}
                            </td>
                            <td className="flp-text">
                              {formatDateTime(info.ActualOutDateTimeUTC)}
                            </td>
                            <td className="flp-text">
                              {formatDateTime(info.ActualOffDateTimeUTC)}
                            </td>
                            <td className="flp-text">
                              {info.DestinationLocation}
                            </td>
                            <td className="flp-text">
                              {formatDateTime(info.SETA)}
                            </td>
                            <td className="flp-text">
                              {formatDateTime(info.EstimatedInDateTimeUTC)}
                            </td>
                            <td className="flp-text">
                              {formatDateTime(info.ActualOnDateTimeUTC)}
                            </td>
                            <td className="flp-text">
                              {formatDateTime(info.ActualInDateTimeUTC)}
                            </td>
                            {/* <td className="flp-text">{info.Dispatcher}</td> */}
                            {/* <td className="flp-text">{info.D}</td> */}
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}{" "}
          {error ? (
            errorMessage
          ) : noFlightPathData ? (
            noDataMessage
          ) : (
            <div></div>
          )}
        </div>
      </>
    );
  }

    const fetchFlightPath = async () => {
    const shouldCheckTail = typeof isTailValid === "boolean";
    const isValid = userData.profile.company && aircraftNumber.length === 5 && (!shouldCheckTail || isTailValid);

    if (isValid) {
      if (!flightPathInfo || Object.keys(flightPathInfo).length === 0) {
        const formattedACNumber = "N" + aircraftNumber;
        getLatestAccessToken().then((token: any) => {
          userData.access_token = token;
          getFlightPath(userData, formattedACNumber)
            .then((flightPathDetails: FlightLeg[]) => {
              if (flightPathDetails.length === 0) {
                setNoData(true);
              }
              dispatch(viewflightSchedule(flightPathDetails));
            })
            .catch((err) => {
              console.log("Failed to fetch flight path: " + err);
              dispatch(viewflightSchedule([]));
              setError(true);
            });
        });
      }
    } else {
      dispatch(viewflightSchedule([]));
      setError(false);
    }
  };

  useEffect(() => {
    fetchFlightPath();
  }, [userData, aircraftNumber]);

  return (
    <React.Fragment>
      <FlightPathTable flightPathInfos={flightPathInfo} />
    </React.Fragment>
  );
};
export default FlightPath;
